export const PHONE_MIN_DIGITS = 7;
export const PHONE_MAX_DIGITS = 15;

export function phoneDigitCount(text: string): number {
  return text.replace(/\D/g, '').length;
}

export function sanitizePhoneTyping(raw: string): string {
  const plus = raw.trimStart().startsWith('+') ? '+' : '';
  return plus + raw.replace(/\D/g, '').slice(0, PHONE_MAX_DIGITS);
}
